import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map, shareReplay, switchMap } from 'rxjs/operators';
import { VBC_HOST } from '../injection-tokens';
import { Order } from './interface';
import { convertOrderFormFields } from './utils';

// Used to pluck the order form id from the api request
const ORDER_FORM_SUBMISSION_ID = 'orderFormSubmissionId';

@Injectable()
export class ActivateAppApiService {
  private submitOrderFormUrl: string;

  constructor(
    @Inject(VBC_HOST) private vbcHost: string,
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    private httpClient: HttpClient,
  ) {
    this.submitOrderFormUrl = `${this.vbcHost}/ajax/v1/orderFormSubmission/create/`;
  }

  createOrderForm(order: Order): Observable<string> {
    return this.partnerId$.pipe(
      first(),
      switchMap((partnerId) => {
        const commonFields = convertOrderFormFields(order.commonFields || []);
        const customFields = convertOrderFormFields(order.customFields || []);
        const data = {
          partnerId: partnerId,
          accountGroupId: order.businessId,
          productId: order.appId,
          commonFields: commonFields,
          customFields: customFields,
        };
        return this.httpClient.post<{ data: { [ORDER_FORM_SUBMISSION_ID]: string } }>(this.submitOrderFormUrl, data, {
          withCredentials: true,
        });
      }),
      map((resp: { data: { [ORDER_FORM_SUBMISSION_ID]: string } }) => {
        return resp.data.orderFormSubmissionId;
      }),
      shareReplay(1),
    );
  }
}
